export default {"src":"/_next/static/media/percentage.85d9e8df.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};